module.exports = __webpack_public_path__ + "img/img14.e55ce9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img14.png
// module id = 362
// module chunks = 0